var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"spinner"}),_c('span',{staticClass:"loader-text"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }